import { render, staticRenderFns } from "./bannerList.vue?vue&type=template&id=3c190e87&scoped=true"
import script from "./bannerList.vue?vue&type=script&lang=js"
export * from "./bannerList.vue?vue&type=script&lang=js"
import style0 from "./bannerList.vue?vue&type=style&index=0&id=3c190e87&prod&lang=less&scoped=true"
import style1 from "./bannerList.vue?vue&type=style&index=1&id=3c190e87&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c190e87",
  null
  
)

export default component.exports